import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSEO from "@/lib/useSEO";
import { SITE } from "@/lib/site";

export default function NotFound() {
    useSEO({
        title: `Not found — ${SITE.brand}`,
        description: "The page you're looking for doesn't exist.",
    });
    return (
        <main
            data-testid="page-not-found"
            style={{
                minHeight: "70vh",
                display: "grid",
                placeItems: "center",
                background: "var(--brand-cream)",
            }}
        >
            <div
                className="brand-container fade-rise"
                style={{ textAlign: "center", padding: "4rem 1rem" }}
            >
                <span
                    className="eyebrow"
                    style={{ justifyContent: "center", display: "inline-flex" }}
                >
                    Page not found
                </span>
                <h1
                    className="h1"
                    style={{
                        fontSize: "clamp(3rem, 8vw, 5.5rem)",
                        marginTop: "1rem",
                    }}
                    data-testid="not-found-code"
                >
                    4
                    <span style={{ color: "var(--brand-red)" }}>0</span>4
                </h1>
                <p
                    style={{
                        marginTop: "1rem",
                        color: "var(--brand-muted)",
                        maxWidth: 480,
                        marginLeft: "auto",
                        marginRight: "auto",
                    }}
                >
                    The page you were looking for doesn't exist or has moved.
                    Let's get you back home.
                </p>
                <Link
                    to="/"
                    className="btn btn-primary"
                    data-testid="not-found-cta"
                    style={{ marginTop: "1.5rem" }}
                >
                    <ArrowLeft size={18} />
                    Back to home
                </Link>
            </div>
        </main>
    );
}
